import React, { useState } from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { SIZES } from "theme";
import { PrettoSlider } from "./Payload";

const Commute = ({ getDetails, small, vehicle }) => {
  const [monthlyCommute, setMonthlyCommute] = useState(2400);
  const [dailyCommute, setDailyCommute] = useState(80);
  const handleChange = (e) => {
    getDetails(e.target.value, "dailyCommute");
    setDailyCommute(e.target.value);
    setMonthlyCommute(28 * e.target.value);
  };

  return (
    <Box display="flex" justifyContent="space-between" gap="24px">
      <Box display="flex" flexDirection="column" flex="1">
        <Box
          background="#1C1C1C"
          b={small ? "none" : "1px solid #333333"}
          h={small ? "158px" : "135px"}
        >
          <Box margin="24px">
            <Text
              fontSize={small ? SIZES.fourteen : "16px"}
              fontWeight="bold"
              textColor="white"
            >
              Your Daily Commute
            </Text>

            <Box>
              <Box>
                <PrettoSlider
                  valueLabelDisplay="on"
                  aria-label="pretto slider"
                  min={50}
                  max={vehicle == 'StormEV' ? 200 : 120}
                  step={1}
                  sx={{ marginTop: "17px" }}
                  defaultValue={60}
                  onChange={handleChange}
                  value={dailyCommute}
                />
                <Box
                  display="flex"
                  justifyContent="space-between"
                  color="white"
                >
                  <Text fontSize={small ? SIZES.fourteen : "14px"} margin="0">
                    50 Km
                  </Text>
                  <Text fontSize={small ? SIZES.fourteen : "14px"} margin="0">
                    {vehicle == 'StormEV' ? 200 : 120} km
                  </Text>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        flex="1"
        marginLeft={small ? "0px" : "10px"}
      >
        <Box background="#1C1C1C" b={small ? "none" : "1px solid #333333"}>
          <Box margin="24px">
            <Text
              fontSize={small ? SIZES.fourteen : "16px"}
              fontWeight="bold"
              textColor="white"
            >
              Your Monthly Commute
            </Text>

            <Box>
              <Box>
                <PrettoSlider
                  valueLabelDisplay="on"
                  aria-label="pretto slider"
                  min={1500}
                  max={vehicle == 'StormEV' ? 5600 : 3600}
                  step={10}
                  value={monthlyCommute}
                />
                <Box
                  display="flex"
                  justifyContent="space-between"
                  color="white"
                >
                  <Text fontSize={small ? "14px" : "14px"} margin="0">
                    1500 Km
                  </Text>
                  <Text fontSize={small ? "14px" : "14px"} margin="0">
                    {vehicle == 'StormEV' ? 5600 : 3600} km
                  </Text>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Commute;
